{
  "id": "campaign-153",
  "name": "Clover Fields",
  "seed": "campaign:153",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".........m............",
    ".....k..mmm...........",
    "..x......m............",
    "............T...Y.....",
    "m.....................",
    ".m....................",
    "....................h.",
    "wwww+wwwwww+w.........",
    ".....ww.....ww....wwww",
    "...T.........wwww+w...",
    "x.........#...........",
    "......................",
    "...x.................k",
    "......................",
    ".................hm...",
    ".................mmm..",
    "...Y..........h...m...",
    "......................",
    "......................",
    ".............T.#......",
    "...T.................S"
  ],
  "critters": [
    {
      "kind": "stag",
      "x": 11,
      "y": 13
    },
    {
      "kind": "fox",
      "x": 7,
      "y": 19
    },
    {
      "kind": "deer",
      "x": 6,
      "y": 0
    },
    {
      "kind": "deer",
      "x": 7,
      "y": 0
    },
    {
      "kind": "fox",
      "x": 8,
      "y": 5
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 6,
      "y": 16
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 7,
      "y": 20
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 18
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 19,
      "y": 7
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 1,
      "y": 8,
      "w": 5,
      "h": 5
    },
    {
      "x": 9,
      "y": 11,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 153,
  "biome": "meadow",
  "par": {
    "reel": 15435,
    "push": 13625,
    "selfPropelled": 12216,
    "tractor": 10895,
    "zeroTurn": 8802,
    "fairway": 5718
  },
  "goldTime": {
    "reel": 15435,
    "push": 13625,
    "selfPropelled": 12216,
    "tractor": 10895,
    "zeroTurn": 8802,
    "fairway": 5372
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 21,
      "zeroTurn": 0,
      "fairway": 20
    },
    "gold": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 21,
      "zeroTurn": 0,
      "fairway": 39
    }
  }
}
